import { Grid, Typography } from '@material-ui/core';

const PlanType = (props) => {
  const { classes, planTypeText, planTypeValue } = props;
  return (
    <Grid item container className={classes.itemContainer}>
      <Grid item className="planType-text" xs={12} sm={6}>
        <Typography variant="body1">{planTypeText}</Typography>
      </Grid>
      <Grid item className="planType-value" xs={12} sm={6}>
        <Typography className={classes.semiBold}>{planTypeValue}</Typography>
      </Grid>
    </Grid>
  );
};

export default PlanType;
